// auth-interceptor.service.ts
import { HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs';
import { LoaderService } from './loader.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  // constructor(private mockAuthService: MockAuthService) {}

  // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   if (environment.mockAuthentication) {
  //     const authToken = this.mockAuthService.getToken();
  //     if (authToken) {
  //       const authReq = req.clone({
  //         headers: req.headers.set('Authorization', `Bearer ${authToken}`)
  //       });
  //       return next.handle(authReq);
  //     }
  //   }
  //   return next.handle(req);
  // }

  constructor(public loaderService: LoaderService) { }
    // private totalRequests = 0;
    // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //     this.loaderService.show();
    //     return next.handle(req).pipe(
    //         finalize(() => this.loaderService.hide())
    //     );
    // }


    private totalRequests = 0;

  intercept(request: HttpRequest<any>, next: HttpHandler): any  {
    this.totalRequests++;
    if (!request.url.endsWith("sendCustomDateNotification")){
      this.loaderService.show();
    }
    return next.handle(request).pipe(
      tap(res => {
        if (res instanceof HttpResponse) {
          this.decreaseRequests();
        }
      }),
      catchError(err => {
        this.decreaseRequests();
        throw err;
      })
    );
    
  }

  private decreaseRequests() {
    // console.log("total"+this.totalRequests)
    this.totalRequests--;
    
    if (this.totalRequests === 0) {
      // console.log("after decriment"+this.totalRequests)
      this.loaderService.hide();
    }
  }
}